import React from 'react';
import type { ISODateRange } from 'shared/src/date-string-utils/types';
import { getDateRangeState } from './metric-date-utils';
import { UnitsPacingMetric } from './units-pacing-metric';
import { SpendPacingMetric } from './spend-pacing-metric';
import { MarginOverUnderMetric } from './margin-over-under-metric';
import { UnitCostOverUnderMetric } from './unit-cost-over-under-metric';
import { UnitsProgressMetric } from './units-progress-metric';
import { SpendProgressMetric } from './spend-progress-metric';

type LineItemHeroMetricsProps = {
  dateRange: ISODateRange;
};

export function LineItemHeroMetrics({ dateRange }: LineItemHeroMetricsProps) {
  const state = getDateRangeState(dateRange);
  const isExpired = state === 'expired';

  if (isExpired) {
    return (
      <div className="grid grid-cols-4">
        <div className="px-3 py-4">
          <UnitsPacingMetric dateRange={dateRange} />
        </div>
        <div className="px-3 py-4">
          <SpendPacingMetric dateRange={dateRange} />
        </div>
        <div className="px-3 py-4">
          <MarginOverUnderMetric dateRange={dateRange} />
        </div>
        <div className="px-3 py-4">
          <UnitCostOverUnderMetric dateRange={dateRange} />
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-3">
      <div className="px-3 py-4">
        <UnitsPacingMetric dateRange={dateRange} />
      </div>
      <div className="px-3 py-4">
        <SpendPacingMetric dateRange={dateRange} />
      </div>
      <div className="px-3 py-4">
        <MarginOverUnderMetric dateRange={dateRange} />
      </div>
      <div className="relative flex items-center px-3 py-4 before:absolute before:inset-x-0 before:top-0 before:h-px before:bg-gradient-to-r before:from-[#58759D00] before:via-[#58759D] before:to-[#58759D00]">
        <UnitsProgressMetric dateRange={dateRange} />
      </div>
      <div className="relative flex items-center px-3 py-4 before:absolute before:inset-x-0 before:top-0 before:h-px before:bg-gradient-to-r before:from-[#58759D00] before:via-[#58759D] before:to-[#58759D00]">
        <SpendProgressMetric dateRange={dateRange} />
      </div>
      <div className="relative flex items-center px-3 py-4 before:absolute before:inset-x-0 before:top-0 before:h-px before:bg-gradient-to-r before:from-[#58759D00] before:via-[#58759D] before:to-[#58759D00]">
        <UnitCostOverUnderMetric dateRange={dateRange} />
      </div>
    </div>
  );
}
